import $ from 'jquery';
window.$ = $;

$(document).ready(function() {
    $('.accordeon h4').on('click', function() {
        $(this).parent().toggleClass('open');
    });
});
